import { useEffect } from "react";
import { motion } from "framer-motion";
import { site } from "@/data/site";

export const Loader = ({ onDone }) => {
    useEffect(() => {
        const t = setTimeout(onDone, 1900);
        return () => clearTimeout(t);
    }, [onDone]);

    return (
        <motion.div
            data-testid="luxury-loader"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ivory"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
            <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-champagne/25 blur-[120px]" />

            <motion.img
                src={site.logo}
                alt="Swastik Realty"
                className="relative h-28 w-28 object-contain md:h-36 md:w-36"
                initial={{ opacity: 0, scale: 0.9, filter: "blur(6px)" }}
                animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            />

            <motion.div
                className="relative mt-6 flex items-center gap-4"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
            >
                <span className="h-px w-8 bg-champagne" />
                <span className="text-[11px] uppercase tracking-luxe text-charcoal/70">
                    {site.values}
                </span>
                <span className="h-px w-8 bg-champagne" />
            </motion.div>
        </motion.div>
    );
};
